import { toast } from "react-toastify";

const toastConfig = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  draggable: true,
  theme: "dark",
};

export const notifySuccess = (text) => {
  toast.success(text, toastConfig);
};

export const notifyWarning = (text) => {
  toast.warning(text, toastConfig);
};

export const notifyError = (text) => {
  toast.error(text, toastConfig);
};

export const notifyInfo = (text) => {
  toast.info(text, toastConfig);
};

export const notifyPromise = (
  promise,
  {
    pending = "Loading...",
    success = "Success!",
    error = "Error!",
    onSuccess = () => {},
    onError = () => {},
  } = {}
) => {
  return toast.promise(
    promise,
    {
      pending: {
        render() {
          return pending;
        },
      },
      success: {
        render({ data }) {
          onSuccess(data);
          return typeof success === 'function' ? success(data) : success;
        },
      },
      error: {
        render({ data }) {
          onError(data);
          return typeof error === 'function' ? error(data) : `${data}`;
        },
      },
    },
    toastConfig
  );
}; 